import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createOwnSplitSupplyNotices,
  getOwnSplitSupplyNotice,
  listOwnSplitSupplyNotices,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 計画作成 (自社の通告値の作成) mutation hook。 成功したら一覧と詳細を最新化する。
 */
export function useCreateOwnSplitSupplyNotices(): InvalidatingMutationResultFor<
  typeof createOwnSplitSupplyNotices
> {
  return useInvalidatingMutation(createOwnSplitSupplyNotices, [
    createConnectQueryKey({
      schema: listOwnSplitSupplyNotices,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getOwnSplitSupplyNotice,
      cardinality: 'finite',
    }),
  ])
}
